// Exports
export default {
	"description": "description_jryeE",
	"title": "title_2uKMY",
	"tip": "tip_Kbaxm",
	"stopButton": "stopButton_vtn5n",
	"stopButtonContent": "stopButtonContent_VGIwr"
};
